import { useQuery } from '@tanstack/react-query';
import { billingApi, type BillingPreview } from '../../services/api/billing';

const BILLING_QUERY_KEY = ['billing', 'current'] as const;

/**
 * Live preview of the current org's projected monthly + annual bill, based on
 * its active child count and effective tier. Read-only — no charges.
 */
export const useCurrentBilling = (enabled = true) =>
  useQuery<BillingPreview>({
    queryKey: BILLING_QUERY_KEY,
    queryFn: () => billingApi.getCurrentBilling(),
    enabled,
    // Cache for a minute — child count doesn't change every second.
    staleTime: 60 * 1000,
  });
